export class EntityListRequest {
    constructor(payload, entityData) {
      this.entityType = payload?.toUpperCase() ?? null;
      this.entityName = entityData?.entityName ?? '';
      this.entityCode = entityData?.entityCode ?? '';
      this.paging = {
        pageNumber: 1,
        pageSize: 500,
      };
    }
  }
  